/**
 * Il logo di un'azienda in una tessera bianca. Senza logo (o se l'immagine non arriva), l'iniziale sul colore del suo
 * marchio: mai un riquadro vuoto.
 */
import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../theme';

interface Props {
  nome: string;
  logoUrl: string | null;
  colore: string | null;
  dimensione: number;
}

export const LogoAzienda: React.FC<Props> = ({ nome, logoUrl, colore, dimensione }) => {
  const { t } = useTranslation('mappa');
  const [rotto, setRotto] = useState(false);
  const conLogo = !!logoUrl && !rotto;
  return (
    <Box
      sx={{
        width: dimensione,
        height: dimensione,
        flexShrink: 0,
        borderRadius: `${Math.round(dimensione / 5)}px`,
        border: `1px solid ${conLogo ? tokens.color.line : 'transparent'}`,
        bgcolor: conLogo ? tokens.color.paper : (colore ?? tokens.color.ash),
        display: 'grid',
        placeItems: 'center',
        overflow: 'hidden',
      }}
    >
      {conLogo ? (
        <Box
          component="img"
          src={logoUrl}
          alt={t('scheda.logo', { nome })}
          loading="lazy"
          onError={() => setRotto(true)}
          sx={{ maxWidth: '80%', maxHeight: '80%', objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <Box
          component="span"
          aria-hidden
          sx={{
            fontFamily: tokens.font.display,
            fontWeight: 600,
            fontSize: dimensione * 0.44,
            color: tokens.color.paper,
            lineHeight: 1,
          }}
        >
          {nome.trim().charAt(0).toUpperCase()}
        </Box>
      )}
    </Box>
  );
};
